export type MultiBuyerRole = 'multiBuyer' | 'masterMultiBuyer' | 'mbManager';
export type EntityType = 'owned' | 'servicePartner';
export type MultiBuyerCompany = 'yougov' | 'quantilope' | 'none';

export const MULTI_BUYER_ROLES: readonly MultiBuyerRole[] = [
  'multiBuyer',
  'masterMultiBuyer',
  'mbManager',
];

export const MULTI_BUYER_ROLES_NUM_MASK = {
  multiBuyer: 6,
  mbManager: 6,
  masterMultiBuyer: 7,
};

export function isMultiBuyerRole(value: unknown): value is MultiBuyerRole {
  return MULTI_BUYER_ROLES.includes(value as MultiBuyerRole);
}

export interface AccessibleEntity {
  id: number;
  type: EntityType;
}

export interface BuyerCapabilities {
  canManageBuyerSettings: boolean;
  canCreateTemplate: boolean;
  canSeeMarginAndBank: boolean;
  hasAccessToTemplate: boolean;
  canSeeCustomTemplates: boolean;
  canManageSupplierSettings: boolean;
  canSeeSupplierBlends: boolean;
  canSeeOperatorProjectManager: boolean;
  canSeeCrmId: boolean;
  canAccessMasterTemplate: boolean;
}

export interface AccessControlConfig {
  clientId: number;
  userRole?: MultiBuyerRole;
  clientName: MultiBuyerCompany;
  buyerAcssLvls: number;
  multiBuyerCmps: Array<number>;
  capabilities: BuyerCapabilities;
  accessibleEntities: AccessibleEntity[];
}

export interface IMultiBuyerPermissions {
  canManageBuyerSettings(): boolean;
  canCreateTemplate(): boolean;
  canSeeMarginAndBank(): boolean;
  hasAccessToTemplate(): boolean;
  canSeeCustomTemplates(): boolean;
  canSeeOperatorProjectManager(): boolean;
  canSeeCrmId(): boolean;
  canManageSupplierSettings(): boolean;
  canSeeSupplierBlends(): boolean;
  canAccessMasterTemplate(): boolean;
}
